/** Landing copy and samples. Numbers and lists come from the product plan and design doc only. */

export const START_CTA = "무료로 시작하기";
export const START_HREF = "/console";

export interface IndustrySample {
  id: string;
  name: string;
  good: string[];
  bad: string[];
  places: string[];
}

/** The five MVP industry templates (design doc 1.1) with sample chips from the plan (section 4). */
export const INDUSTRY_SAMPLES: IndustrySample[] = [
  {
    id: "restaurant",
    name: "음식점, 카페",
    good: ["맛", "양", "친절", "분위기", "주차"],
    bad: ["대기", "소음", "가격"],
    places: ["네이버 플레이스", "카카오맵", "Google 지도"],
  },
  {
    id: "beauty",
    name: "미용, 네일, 뷰티",
    good: ["상담", "손기술", "위생", "예약 편함"],
    bad: ["시간 지연", "가격"],
    places: ["네이버 플레이스", "카카오헤어샵", "Google 지도"],
  },
  {
    id: "app",
    name: "모바일 앱, 게임",
    good: ["쓰기 쉬움", "원하던 기능", "광고 적음", "꾸준한 업데이트"],
    bad: ["로딩 느림", "특정 버그"],
    places: ["App Store", "Google Play"],
  },
  {
    id: "ecommerce",
    name: "쇼핑몰, 상품",
    good: ["품질", "배송", "포장", "사이즈"],
    bad: ["색 차이", "배송 지연"],
    places: ["스마트스토어", "쿠팡", "직접 입력한 주소"],
  },
  {
    id: "general",
    name: "그 밖의 서비스",
    good: ["응대", "설명", "일정 지킴", "깔끔한 마무리"],
    bad: ["기다림", "가격"],
    places: ["네이버 플레이스", "Google 지도", "직접 입력한 주소"],
  },
];

export const FAQ: Array<{ q: string; a: string }> = [
  {
    q: "손님 개인정보를 받나요?",
    a: "받지 않아요. 이름, 연락처, 계정을 묻지 않고 로그인도 없어요. 손님이 고른 칩과 초안도 저장하지 않고, 열림이나 복사 같은 횟수만 셉니다.",
  },
  {
    q: "AI가 쓴 후기라서 문제가 되지 않을까요?",
    a: "초안은 손님이 고른 사실로만 만들고, 손님이 읽고 고쳐서 자기 계정으로 올려요. 사장님이 원하면 초안 끝에 'AI 도움을 받아 썼어요' 한 줄을 붙일 수 있어요.",
  },
  {
    q: "별점은 어디서 매기나요?",
    a: "텔뷰는 별점을 묻지도 저장하지도 않아요. 손님이 후기를 올리는 곳에서 직접 매겨요. 만족도에 따라 손님을 다른 곳으로 보내지도 않아요.",
  },
  {
    q: "어디에 후기를 남길 수 있나요?",
    a: "네이버 플레이스, 카카오맵, Google 지도, App Store, Google Play, 스마트스토어, 쿠팡, 배달의민족, 쿠팡이츠, 요기요, 카카오헤어샵을 고를 수 있고, 목록에 없는 곳은 주소를 직접 넣으면 돼요.",
  },
  {
    q: "칩 문구를 우리 가게에 맞게 바꿀 수 있나요?",
    a: "스탠다드 요금제부터 고칠 수 있어요. 무료 요금제는 업종 칩을 켜고 끄는 것까지예요. '인생 맛집' 같은 과장 표현은 저장 전에 걸러지고, 운영자가 한 번 더 살펴봐요.",
  },
  {
    q: "손님이 쓴 후기를 볼 수 있나요?",
    a: "볼 수 없어요. 저장하지 않으니까요. 콘솔에서는 링크가 열린 수, 초안 생성, 복사, 플랫폼 이동 수와 아쉬운 점을 고른 비율을 보여 드려요.",
  },
  {
    q: "체험단처럼 제품을 제공한 손님은요?",
    a: "페이지에서 '제공받음 표시'를 켜면 초안 끝에 '제품을 제공받아 쓴 후기예요'가 붙고, 손님이 지워도 복사할 때 다시 붙어요.",
  },
];
